import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinish = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 37,
	viewBox: "0 0 27 37",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M29.375 29.9155L21.3745 29.9155L21.3745 37.893L29.375 37.893L29.375 29.9155ZM21.3745 37.893L13.376 37.893L13.376 43L21.3745 43L21.3745 37.893ZM13.376 37.893L13.376 29.9155L5.37548 29.9155L5.37548 37.893L13.376 37.893ZM5.37548 37.893L-2.62404 37.893L-2.62404 43L5.37548 43L5.37548 37.893ZM5.37548 29.9155L5.37548 21.9362L-2.62404 21.9362L-2.62404 29.9155L5.37548 29.9155ZM5.37548 21.9362L13.374 21.9362L13.374 13.9568L5.37548 13.9568L5.37548 21.9362ZM5.37548 13.9568L5.37548 5.97936L-2.625 5.97936L-2.625 13.9568L5.37548 13.9568ZM5.37548 5.97936L13.374 5.97936L13.374 -2L5.37548 -2L5.37548 5.97936ZM13.374 5.97936L13.374 13.9568L21.3745 13.9568L21.3745 5.97936L13.374 5.97936ZM21.3745 5.97936L29.3731 5.97936L29.3731 -2L21.3745 -2L21.3745 5.97936ZM21.3745 13.9568L21.3745 21.9362L29.3731 21.9362L29.3731 13.9568L21.3745 13.9568ZM21.3745 21.9362L13.374 21.9362L13.376 29.9155L21.3745 29.9155L21.3745 21.9362Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFinish);
export { ForwardRef as ReactComponent };
